// removed by extract-text-webpack-plugin
module.exports = {"fadeInTime":"500ms"};


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/schedule.css
// module id = 255
// module chunks = 0